import React from "react"
import Layout from "./layout"
import styled from "styled-components"
import { Link } from "gatsby"

const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding: calc(var(--gutter-l) * 1.5) var(--gutter-s);
  background-color: var(--alabaster);
  min-height: calc(100vh - 194px);
  gap: var(--gutter-s);

  strong {
    font-family: "galano_grotesquemedium";
  }

  @media (min-width: 768px) {
    padding: calc(var(--gutter-l) * 2) var(--gutter-l);
    min-height: calc(100vh - 78px);
  }

  a {
    color: var(--havelock-blue);
  }

  ol {
    padding-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

export default function DeleteAccountPage() {
  return (
    <Layout metaNavbar={true}>
      <Container>
        <h1>Account Deletion</h1>

        <p>
          You can request to delete your Submitt account and associated data at
          any time.
        </p>

        <div>
          <p>
            <strong>Option 1 - Inside the App</strong>
          </p>
          <ol>
            <li>Log in to the Submitt app</li>
            <li>
              Tap the &quot;Settings&quot; button in the bottom right corner
            </li>
            <li>Tap the &quot;My Profile&quot; text</li>
            <li>Tap the &quot;Delete my account&quot; button</li>
            <li>
              Confirm the deletion tapping on the &quot;Delete my account&quot;
              button
            </li>
          </ol>
        </div>

        <div>
          <p>
            <strong>Option 2 - From the Website</strong>

            <ol>
              <li>
                <Link to="/sign-in/">Log in</Link> to the Submitt website
              </li>
              <li>Scroll to the bottom of the page</li>
              <li>Click the &quot;Delete my account&quot; button</li>
              <li>
                Confirm the deletion tapping on the &quot;Delete my
                account&quot; button
              </li>
            </ol>
          </p>
        </div>

        <p>
          Once requested, your account and personal data will be permanently
          deleted within 5 days, except where retention is required by law.
        </p>
      </Container>
    </Layout>
  )
}
